var modalControl = {
  apiKey: '5b7931a7-b19e-c66c-4242-42baa9b5b444',
  hostUrl: 'https://waterapi.ewg.org/',
  apiUrl: 'https://tradewinds.herokuapp.com/index.php',
  _seccua_contamlist: ['1,1-Dichloroethane', '1,1,2-Trichloroethane', '1,2-Dibromo-3- chloropropane', '1,2-Dichloroethane', '1,2-Dichloropropane', '1,2,3-Trichloropropane', '1,2,4-Trichlorobenzene', '1,3-Butadiene', '2,4-D (2,4-dichlorophenoxyacetic acid)', 'Arsenic', 'Atrazine', 'Benzene', 'Benzo[a]pyrene', 'Bromate', 'Bromochloroacetic acid', 'Bromodichloromethane', 'Bromoform', 'Carbofuran', 'Carbon tetrachloride', 'Chlorate', 'Chlordane', 'Chlorite', 'Chlorodibromoacetic acid', 'Chloroform', 'Chloromethane', 'Chromium (hexavalent)', 'Di(2-ethylhexyl) adipate', 'Di(2-ethylhexyl) phthalate', 'Dibromochloromethane', 'Dichloroacetic acid', 'Dichloromethane (methylene chloride)', 'Diquat', 'Endothall', 'Endrin', 'Ethylbenzene', 'Ethylene dibromide', 'Glyphosate', 'Haloacetic acids (HAA5)', 'Heptachlor', 'Heptachlor epoxide', 'Hexachlorobenzene', 'Hexachlorocyclopentadiene', 'Lindane', 'Methoxychlor', 'Monochlorobenzene (chlorobenzene)', 'MTBE', 'Oxamyl', 'p-Dichlorobenzene', 'Pentachlorophenol', 'Perfluorodecanoic acid (PFDA)', 'Perfluorobutane sulfonate (PFBS)', 'Perfluoro-2-methoxyacetic acid (PFMOAA)', 'Perfluoro-2-ethoxypropanoic acid (PEPA)', 'Perfluoro(3,5-dioxahexanoic) acid (PFO2HxA)', 'Perfluoro-2-methoxypropanoic acid (PMPA)', 'Perfluoro-2-methyl-3-oxahexanoic acid (GenX)', 'Perfluoro(3,5,7-trioxaoctanoic) acid (PFO3OA)','Perfluoroheptanoic acid (PFHPA)', 'Perfluorohexane sulfonate (PFHXS)', 'Perfluorononanoic acid (PFNA)', 'Perfluorooctane sulfonate (PFOS)', 'Perfluorooctanoic acid (PFOA)', 'Perfluoro-3-methoxypropanoic acid (PFMOPrA)', 'Perfluorobutanoic Acid (PFBA)', 'Perfluoropentanoic Acid (PFPeA)', 'Picloram', 'Polychlorinated biphenyls (PCBs)', 'Radium, combined (-226 & -228)', 'Simazine', 'Styrene', 'Tetrachloroethylene (perchloroethylene)', 'Toluene', 'Total trihalomethanes (TTHMs)', 'Toxaphene', 'Trichloroacetic acid', 'Trichloroethylene', 'Trichlorofluoromethane', 'Trichlorotrifluoroethane', 'Vinyl chloride', 'Xylenes (total)', 'Haloacetic acids (HAA9)', 'Dibromoacetic acid', 'Perfluorohexanoic Acid (PFHxA)', 'Total PFOS and PFOA'],
  _pfas_clear_filter: [
    "Per- and polyfluorinated alkyl substances (PFAS)",
    "Perfluorooctanoic acid (PFOA)",
    "Perfluorooctane sulfonate (PFOS)",
    "Perfluorononanoic acid (PFNA)",
    "Perfluorohexane sulfonate (PFHXS)",
    "Perfluorobutane sulfonate (PFBS)",
    "Perfluoroundecanoic acid (PFUnA)",
  ],
  _arsenic: 0,
  _pfas_clear: 0,
  _other_critical_list: ["Perfluorooctanoic acid (PFOA)", "Perfluorooctane sulfonate (PFOS)", "Per- and polyfluorinated alkyl substances (PFAS)", "Perfluorodecanoic acid (PFDA)"],
  _recommends: [47656405401885, 45593995182365, 47750983155997],
  _first_name: "",
  _city: "",
  _zip: "",
  _report_data: { "contamcnt": 0, "contams": [], "p_img": "", "p_name": "", "p_price": "", "p_summary": "", "p_desc": "", "buy_url": "", "learn_more_url": "https://tradewindswater.com/collections/frontpage" },
  _p_urls: ['/products/pioneer-one-chloramine-system-good', '/products/pioneer-pfas-system', '/products/e3m-pioneer-arsenic-removal-system'],
  _p_names: ['PIONEER ONE Chloramine System', 'PIONEER PF - PFAS Removal Filtration System', 'PIONEER AS - ARSENIC Removal System'],
    _p_imgs: ['https://tradewindswater.com/cdn/shop/files/one-chloramine-removal-system-silver-316232.png?v=1749093585&width=600',
    'https://tradewindswater.com/cdn/shop/files/pioneer-pf-certified-2-stage-pfas-removal-system-platinum-519977.png?v=1748996583&width=600',
    'https://tradewindswater.com/cdn/shop/files/pioneer-as-2-stage-arsenic-removal-system-345527.png?v=1748996581&width=600'],
  _p_prices: ['$2,088.00', '$3,235.00', '$2,743.00'],
  _p_summaries: [ 
    'Advanced 3-Stage filtration with limescale, toxins, and chloramine protection',
    'Advanced 3-Stage filtration with limescale, toxins, chloramine, Lead and PFAS protection',
    'Advanced 4-Stage filtration with limescale, toxins, chloramine, Lead, PFAS and Arsenic protection'],
  _p_descs: [
    'Eliminates pathogens plus rust and suspended particles in city water while also targeting limescale and toxins through added media filtration.',
    'Certified by IAPMO and tested to NSF/ANSI Standard 53, the system reduces more than 99% of lead and cysts, 98% of PFOA/PFOS, and 90% of chlorine and chloramines.',
    'Certified by IAPMO and tested to NSF/ANSI Standard 53, the system reduces more than 99% of lead and cysts, 98% of PFOA/PFOS, 90% of chlorine and chloramines and Arsenic III and V.'
  ],
  _buy_url: 'https://tradewindswater.com/collections/frontpage',

  numberFormat: function (num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  },
  ppbFormat: function (item, num) {
    if (num == -1) {
      return 'NO LEGAL LIMIT';
    }
    var mul = 1;
    if (item.ContaminantDisplayUnits != item.ContaminantUnits) {
      mul = 1000;
    }
    if (num * mul >= 1) {
      return (num * mul).toFixed(2) + ' ' + item.ContaminantDisplayUnits;
    } else {
      return (num * mul).toFixed(3) + ' ' + item.ContaminantDisplayUnits;
    }
  },

  _calcBar: function (item, num) {
    const ary = [item.SystemAverage, item.ContaminantMCLValue, item.ContaminantHGValue, item.ContaminantStateAvg, item.ContaminantNationalAvg];
    var max = Math.max(...ary);
    var unit = max / 90;
    return num / unit < 1 ? 1 : num / unit;
  },
  _makeUnitDescription: function (unit) {
    var ret = '';
    switch (unit) {
      case 'ppb':
        ret = 'ppb = parts per billion';
        break;
      case 'ppm':
        ret = 'ppm = parts per million';
        break;
      case 'pCi/L':
        ret = 'pCi/L = picocuries per liter';
        break;
    }
    return ret;
  },
  getUtilities: function (zip) {
    var zipcode = zip;

    var _this = this;

    $.get(
      _this.hostUrl + 'zip_systems.php',
      { zip: zipcode, key: this.apiKey },
      function (re) {

        var data = JSON.parse(re);
        var tbody = $('.utilities .utilities-grid');
        tbody.find('.itemc').remove();

        if (data.NumberOfSystems > 0) {
          data.SystemList.sort(function (a, b) { return b.Population - a.Population });
          if (data.NumberOfSystems > 12) {
            if ($('.utilities-grid--trimmed-btn').length) {
            } else {
              $('.utilities-grid').addClass('utilities-grid--trimmed');
              $('.utilities-grid--trimmed').after('<div class="font-size--xs seccua_normal_link pointer utilities-grid--trimmed-btn" style="color: #00378b;">Load More</div>');
              $('.utilities-grid--trimmed-btn').click(function () {
                $('.utilities-grid').removeClass('utilities-grid--trimmed');
                $('.utilities-grid--trimmed-btn').remove();
              });
            }
          }
          for (var i in data.SystemList) {
            tbody.append(`
              <div class="grid m0 itemc" onclick="modalControl.getContaminantsByUtility('${data.SystemList[i].PWS}')" data-utility-location="${data.SystemList[i].PWS}">
                <div class="custom-grid__item">${data.SystemList[i].SystemName}</div>
              </div>
            `);
          }
          _this.getContaminantsByUtility(data.SystemList[0].PWS);

        }

      }
    );
  },
  getContaminantsByUtility: function (pws) {
    var _this = this;
    _this._arsenic = 0;
    _this._pfas_clear = 0;

    var utilityLocation = pws;
    $('.utilities-grid div.grid').removeClass('selected');
    $('.utilities-grid div[data-utility-location=' + utilityLocation + ']').addClass('selected');


    $.get(
      this.hostUrl + 'systeminformation.php',
      { pws: pws, key: this.apiKey },
      function (re) {

        var data = JSON.parse(re);
        var cheader = $('.contaminants');
        var cbody = $('.contamitems');
        var exnum = data.ContaminantList.filter(function (el) { return (el.SystemAverage / el.ContaminantHGValue).toFixed(1) >= 2; }).length;
        _this._report_data.contamcnt = exnum;
        _this._report_data['contams'] = [];

        cheader.find('.contam_counts').html(exnum + ' contaminants');

        // Desktop version
        var itemgridbody = cbody.find('.top-up-grid-blk');
        itemgridbody.html('<div class="topUp-slider topUp-grid items"></div>');
        itemgridbody = cbody.find('.topUp-grid');

        // Mobile version
        var itembody = cbody.find('.top-up-slider-blk');
        itembody.html('<div class="topUp-slider slider items"></div>');
        itembody = cbody.find('.topUp-slider');

        data.ContaminantList = data.ContaminantList.sort((a, b) => (a.SystemAverage / a.ContaminantHGValue < b.SystemAverage / b.ContaminantHGValue) ? 1 : -1);

        for (var i in data.ContaminantList) {
          var item = data.ContaminantList[i];
          if (item.ContaminantHGValue == -1) continue;
          var footer = (_this._seccua_contamlist.indexOf(item.ContaminantName) == -1) ? '' : '<div class="buy-btn text-center"><a>Tradewinds Targeted</a><a onclick="modalControl.nextSection(\'target3\')">Find your Tradewinds system</a></div>';

          var legal = _this.ppbFormat(item, item.ContaminantMCLValue), hguide = _this.ppbFormat(item, item.ContaminantHGValue);
          var frate = (item.SystemAverage / item.ContaminantHGValue) > 10 ? (item.SystemAverage / item.ContaminantHGValue).toFixed(0) : (item.SystemAverage / item.ContaminantHGValue).toFixed(1);

          // Arsenic checking
          if (item.ContaminantName == 'Arsenic') _this._arsenic = frate;

          // PFAS CLEAR checking
          if ((_this._pfas_clear_filter.indexOf(item.ContaminantName) > -1) && (frate > 10)) {
            console.log('item.ContaminantName', item.ContaminantName, frate);
            _this._pfas_clear = frate;
          }

          if (legal.includes('NO')) {
            legal = `<span style="color: #767676;">${legal}</span>`;
          } else {
            legal = `<span>Legal limit</span><span>${legal}</span>`;
          }
          if (hguide.includes('NO')) {
            hguide = `<span style="color: #767676;">NO EWG HEALTH GUIDELINE</span>`;
          } else {
            hguide = `<span>EWG health guideline</span><span>${hguide}</span>`;
          }
          if (frate >= 2) {
            frate = _this.numberFormat(frate);
            itembody.append(`
                <div class="single-slide">
                  <div class="inner-slider">
                    <div class="heading-para">
                      <span class="sub-title text-center contaminants--title">${item.ContaminantName}</span>
                      <div class="flex items--baseline contaminants--details">
                        <h3 style="white-space: nowrap;">${frate}X</h3>
                        <h4 class="pl1 font-helvetica" style="font-weight: 700;">EWG’s Health Guideline</h4>
                      </div>
                    </div>
                    <div class="slider-listing" style="font-size:12px">
                      <div class="one-whole flex justify--between"><span>Your tap water</span><span>${_this.ppbFormat(item, item.SystemAverage)}</span></div>
                      <div class="one-whole flex justify--between">${hguide}</div>
                      <div class="one-whole flex justify--between">${legal}</div>
                      <div class="pt1  one-whole flex justify--between italic"><span>Potential effect: ${item.ContaminantEffect}</span></div>
                    </div>
                  </div>
                    ${footer}                    
                </div>

              `);
            _this._report_data['contams'].push({
              "contam_name": item.ContaminantName, "ewg_level": _this.ppbFormat(item, item.ContaminantHGValue),
              "ppb_level": _this.ppbFormat(item, item.SystemAverage), "level_higher": frate, "seccua_target": (footer ? "Yes" : "")
            });

          }
        }
        jQuery('.topUp-slider.slider').slick({
          infinite: false,
          slidesToShow: 4,
          arrows: true,
          autoplay: false,
          autoplaySpeed: 5000,
          swipeToSlide: true,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
              }
            }

          ]
        });
        //         $(".g-scrolling-carousel .items").gScrollingCarousel({scrolling: false});

        $(".target1").removeClass('hide');

        _this.nextSection('target0');
        _this.getRecommendation('target2');
      }
    )
  },
  getContaminants: function () {
    var zip = $('.zipcode').val();

    // gtag_report_conversion_zip();

    setTimeout(function () {
      $('.announcement').removeClass('announcement--out');
    }, 800);

    if (!zip) return;
    this._zip = zip;
    this.getUtilities(zip);

    var cheader = $('.contaminants');
    this.getLocation(cheader.find('.location'), zip);

    return;
  },

  nextSection: function (target) {
    $("." + target).removeClass('hide');
    $([document.documentElement, document.body]).animate({
      scrollTop: $("." + target).eq(0).offset().top - 80
    }, 1000);

    window.dispatchEvent(new Event('resize'));
  },

  getRecommendation(target) {
    var flag = true;
    //     window.event.preventDefault();

    $(".product_special").addClass('hide');
    $('.product-recommendation-images').addClass('hide');
    $('.product-recommendation-price--item').addClass('hide');
    $('.product-rec-title').addClass('hide');

    var hardval = "hard_yes"
    if (flag) {
      var fkey = 0;
      console.log('_arsenic', this._arsenic);
      console.log('_pfas_clear', this._pfas_clear);
      if (this._arsenic > 330) {
        $(".shopify-product-form").find("#id").val(this._recommends[2]);
        // $('.product-rec-title').addClass('hide');
        // $('.product-rec-title').eq(2).removeClass('hide');
        $(".add-to-cart-container a").attr("href", this._p_urls[2]);
        $(".product_special").eq(2).removeClass('hide');
        $('.product-recommendation-images').eq(2).removeClass('hide');
        $('.product-recommendation-price--item').eq(2).removeClass('hide');

        fkey = 2;
      } else if (this._pfas_clear > 10) {
        $(".shopify-product-form").find("#id").val(this._recommends[1]);
        // $('.product-rec-title').addClass('hide');
        // $('.product-rec-title').eq(1).removeClass('hide');
        $(".add-to-cart-container a").attr("href", this._p_urls[1]);
        $(".product_special").eq(1).removeClass('hide');
        $('.product-recommendation-images').eq(1).removeClass('hide');
        $('.product-recommendation-price--item').eq(1).removeClass('hide');

        fkey = 1;
      } else {
        $(".shopify-product-form").find("#id").val(this._recommends[0]);
        // $('.product-rec-title').addClass('hide');
        // $('.product-rec-title').eq(0).removeClass('hide');
        $(".add-to-cart-container a").attr("href", this._p_urls[0]);
        $(".product_special").eq(0).removeClass('hide');
        $('.product-recommendation-images').eq(0).removeClass('hide');
        $('.product-recommendation-price--item').eq(0).removeClass('hide');

        fkey = 0;
      }

      this._report_data.p_name = this._p_names[fkey];
      this._report_data.p_img = this._p_imgs[fkey];
      this._report_data.p_price = this._p_prices[fkey];
      this._report_data.p_summary = this._p_summaries[fkey];
      this._report_data.p_desc = this._p_descs[fkey];
      this._report_data.buy_url = `${this._buy_url}#${fkey}`;
      //       this.nextSection(target);
      $('#recommendation').removeClass('hide');
      $('#emaillead').removeClass('hide');

      $('.product-recommendation-price').text(this._p_prices[fkey]);
    }
  },

  getLocation(obj, zipcode) {
    // var clientKey = "js-Wxk8ZJukrIrX5l5uBOIs2AzFb8ntVNt8wcYudvXgMeWd8LcKpt8mV2ZaaP0CkSys";
    // var clientKey = "js-WOLnjU5Fl9tQpSWmRCxgTTBaQo2VEHpjbNi8kb9GmQ10wYP7DTfwzCP28HeSJ2bm";
    var clientKey = "js-H8IZOIHutGFR0mSEkjPpJbQukIqKmKONKfklvzDdj90qbTY9hfmlcrW1evlbbiLh";
    // var clientKey = "js-aeGIUf8NRPBvr8xBJOeH3hT2d9nPrWZAiOmSldHO6Ej1LaDRDwn3eee4cGPi2iwy";
    var url = "https://www.zipcodeapi.com/rest/" + clientKey + "/info.json/" + zipcode + "/radians";
    obj.html('');
    var _this = this;
    if (zipcode.length == 5 && /^[0-9]+$/.test(zipcode)) {
      $.ajax({
        "url": url,
        "dataType": "json"
      }).done(function (data) {
        _this._city = `${data.city}, ${data.state}`;
        obj.html(_this._city);
      }).fail(function (data) {

      });
    }
  }
}

$(document).on('keyup', '.zipcode', function (e) {
  if (e.keyCode == 13) {
    modalControl.getContaminants();

    setTimeout(function () { modalControl.getRecommendation('target2'); }, 100);

  }
});


function showUtilities() {
}

// Event snippet for Google - Zip Code Submit conversion page //
function gtag_report_conversion_zip() {
  gtag('event', 'conversion', {
    'send_to': 'AW-596738078/IgtyCIz7ve4BEJ6AxpwC',
    'event_label': 'EWG Report Zip Code Submission',
  });
  return false;
}


// Event snippet for EWG-Sign-up conversion page //
function gtag_report_conversion_email_signup() {
  gtag('event', 'conversion', {
    'send_to': 'AW-596738078/xyieCKjzve4BEJ6AxpwC',
    'event_label': 'EWG Report Email Signup Submission',
  });
  return false;
}

$('.utilities-trigger').click(function () {
  $('#utilities').addClass('active');
  //       $([document.documentElement, document.body]).animate({
  //         scrollTop: $('#utilities').offset().top - 80
  //     }, 1000);
});

$('#question label').click(function () {
  var ind = $(this).closest('.slideshow__slide').index();
  $('#question').find('.flickity-page-dots').find('li').eq(ind + 1).click();

  //   setTimeout(function(){modalControl.getRecommendation('target2');},100);
});

$('.slider-listing label').click(function () {
  $(this).parents(".slider-listing").addClass('selection-made');
  $(this).addClass('selected');
  $('#question .slick-slider').slick('slickNext');
});
$('#report_form').bind('submit', function (e) {
  $('.target2').addClass('loading-section');
  $('#report_form button').html("Sending");

  // gtag_report_conversion_email_signup();

  var email = $(this).find('input').val();
  $.ajax({
    "url": modalControl.apiUrl,
    "dataType": "json",
    "method": "POST",
    "data": { email: email, firstname: "Dear", zip: modalControl._zip, city: modalControl._city, datas: modalControl._report_data }
  }).done(function (data) {
    $('#report_form').find('input').val('');
    $('.target2').removeClass('loading-section');
    $('#report_form button').html("Sent");
    $('.emailsignup-success').show();
    modalControl.nextSection('target2');

    //     $('.target2 .emailsignup-note').append('<p class="emailsignup-success">Your water report and coupon have been sent to your email. Please check your inbox.</p>');
  }).fail(function (data) { });
  e.preventDefault();
  return false;
});

